import { InputNumber } from 'antd';
import React from 'react';
import {
  FloatVariableModel,
  IntegerVariableModel,
} from '../../iasConfigSchema';
import VariableFormItem from '../variables/VariableFormItem';

const NumberWidget: React.FC<{
  variable: FloatVariableModel | IntegerVariableModel;
  disabled: boolean;
}> = ({ variable, disabled }) => {
  return (
    <VariableFormItem variable={variable}>
      <InputNumber
        disabled={disabled}
        step={variable.step ?? undefined}
        min={variable.min ?? undefined}
        max={variable.max ?? undefined}
      />
    </VariableFormItem>
  );
};

export default NumberWidget;
